<template>
  <div class="wrapper"
    v-swipe="onSwipe"
  >
    <div
        class="slider"
        ref="slider"
        :class="{ swiped: swiped && !moving, moving }"
        :style="moving ? `transform: ${translateX}` : ''"
    >
        <div class="notification" :class="{ isNew }">
            <div class="row">
                <div class="flex space-between">
                    <div class="flex">
                        <div
                            class="bullet"
                            :style="{ backgroundColor: value.category_color}"
                        ></div>
                        <div class="type">

                            {{ value.category_name }}
                        </div>
                    </div>

                    <div class="date">
                        {{ value.created_at | timestampFullDate(true) }}
                    </div>
                </div>
                <div class="remove" @click="$emit('remove')" ></div>
            </div>
            <div class="text">{{ value.text }}</div>
            <div class="flex">
                <a
                    @mousedown.prevent
                    class="link"
                    :href="value.link_url"
                >
                    <span>{{ value.link_text }}</span>
                </a>
            </div>
        </div>
        <div class="swipe-remove" @click="$emit('remove')">
            <span>Удалить</span>
        </div>
    </div>

  </div>
</template>

<script>
export default {
    data: () => ({
        moving: false,
        translateX: '',
        startOffset: 0,
        isNew: false,
    }),
    created(){
        this.isNew = this.value.status !== 'reed';
        if (this.isNew) {
            this.$store.dispatch('readNotification', this.value.id);
        }
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        swipe: {
            type: Number,
            required: false,
        },
    },
    computed: {
        swiped() {
            return this.swipe == this.value.id;
        },
    },
    methods: {
        onSwipe(e) {
            switch (e.type) {
                case 'swipe':
                    if (e.axis === 'x') {
                        if (e.direction == 1) {
                            this.$emit('update:swipe', this.value.id);
                        }
                        if (e.direction == -1) {
                            this.$emit('update:swipe', null);
                        }
                    }
                    break;
                case 'touchmove':
                    this.translateX = `translateX(${Math.max(
                        -window.innerWidth / 3,
                        Math.min(-e.value.x, this.startOffset)
                    )}px)`;
                    break;
                case 'touchstart':
                    let v = this.swiped
                        ? parseInt(window
                            .getComputedStyle(this.$refs.slider)
                            .getPropertyValue('transform')
                            .split(',')[4]
                        ) : 0;
                    this.startOffset = v;
                    this.translateX = `translateX(${v}px)`;
                    this.moving = true;
                    break;
                case 'touchend':
                    this.moving = false;
                    this.translateX = 'translateX(0)';
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';

    .slider {
        width: 100%;
        display: flex;
    }

    .swipe-remove {
        display: none;
    }


    @include on-mobile {
        .slider {
            transition: transform .3s ease;
            width: 100rem + mrem(80);
            &.moving {
                transition: none;
            }
            &.swiped {
                transform: translateX(mrem(-80));
            }
        }

        .swipe-remove {
            border: 0;
            display: block;
            display: flex;
            align-items: center;
            width: mrem(80);
            height: auto;
            padding: 0 mrem(14);
            background: #F78EA2;
            span {
                font-family: "Montserrat";
                font-style: normal;
                font-weight: 600;
                font-size: mrem(12);
                line-height: mrem(15);
                text-align: right;
                color: #FFFFFF;
            }
        }
    }

    .notification {
        width: 100%;
        padding: rem(24);
        text-align: start;

        @include on-mobile {
            padding: mrem(24);
        }

        &.isNew {
            background-color: #F4F4F4;
        }
    }

    .row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .bullet {
        display: block;
        width: rem(6);
        height: rem(6);
        border-radius: 50%;
        margin-top: rem(4);
        padding: 3px;
        margin-right: rem(8);


        @include on-mobile {
            width: mrem(8);
            height: mrem(8);
            border-radius: mrem(4);
            margin-top: mrem(2);
            margin-right: mrem(8);
        }
    }

    .flex {
        display: flex;
        &.space-between {
            width: 98%;
            justify-content: space-between;
        }
    }

    .type,
    .date {
        font-family: "Montserrat";
        display: inline-block;
        font-weight: 600;
        font-size: rem(12);
        line-height: rem(15);
        color: #98A0A9;
        padding-right: rem(12);

        @include on-mobile {
            font-size: mrem(12);
            line-height: mrem(15);
            padding-right: mrem(12);
        }
    }

    .remove {
        width: rem(16);
        height: rem(16);
        background: url(../../../assets/images/UI/close-grey.svg);
        background-size: cover;

        @include on-mobile {
            display: none;
        }
    }

    .text {
        width: 100%;
        font-family: "Open Sans";
        font-size: rem(14);
        line-height: rem(20);
        color: #2A2626;
        margin-top: rem(12);

        @include on-mobile {
            margin-top: mrem(12);
            font-size: mrem(14);
            line-height: mrem(20);
        }
    }

    .link {
        display: inline-block;
        font-family: "Montserrat",sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(13);
        line-height: rem(18);
        color: $color-main-primary;
        margin-top: rem(16);
        text-decoration: none;

        span {
            border-bottom: rem(1) solid $color-main-primary;
            width: calc(100%);

            @include on-mobile {
                border-bottom: mrem(1) solid $color-main-primary;
            }
        }

        @include on-mobile {
            font-size: mrem(13);
            line-height: mrem(18);
            margin-top: mrem(16);
        }
    }
</style>
